import { createContext, } from 'react';

const PacksContext = createContext({});

export default PacksContext;